import type { AnyObject } from '@/common';
import type { IDocumentState } from '../hooks/useDocumentState';
import type { IDocument } from '@/components/organisms/Form/DocumentsService/types';
import get from 'lodash/get';
import type { TDeepthLevelStack } from '@/components/organisms/Form/Validator';
import { formatValueDestination } from '@/components/organisms/Form/Validator';
import { isValueAnEntity } from '../../../helpers/is-value-an-entity/is-value-an-entity';
import { isValueBusinessId } from '../../../helpers/is-value-business-id/is-value-business-id';

export const buildDocumentFieldThisState = (
  context: AnyObject,
  _metadata: AnyObject,
  stack: TDeepthLevelStack,
) => {
  const { element } = _metadata;

  if (!element) {
    return {
      $this: undefined,
    };
  }

  const elementContext: IDocumentState = {
    document: undefined,
    element,
  };

  const bussinessIdOrEntity = get(context, formatValueDestination(element.valueDestination, stack));

  if (isValueAnEntity(bussinessIdOrEntity)) {
    const entity = bussinessIdOrEntity;

    elementContext.document = context._documents?.find(
      (document: IDocument) =>
        document.endUserId === entity.ballerineEntityId &&
        document.type === element.params.template.type &&
        document.category === element.params.template.category,
    );
  }

  if (isValueBusinessId(bussinessIdOrEntity)) {
    elementContext.document = context._documents?.find(
      (document: IDocument) =>
        document.type === element.params.template.type &&
        document.category === element.params.template.category &&
        !document.endUserId,
    );
  }

  return { $this: elementContext };
};
